import AuthLangButton from "@/components/authLangButton/AuthLangButton";
import AuthHeroSection from "./AuthHeroSection";
import { useTranslation } from "react-i18next";
import { object, string } from "yup";
import { useFormik } from "formik";
import { useRef } from "react";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import axios, { AxiosError } from "axios";

import { useNavigate, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { setToken } from "@/store/token.slice";
import { setUser } from "@/store/user.slice";
import { setResturant } from "@/store/resturant.slice";


export default function AcceptInvite() {
    const { t, i18n } = useTranslation();
    const locale = i18n.language
    const baseUrl = import.meta.env.VITE_BASE_URL

    const passwordRef = useRef<HTMLInputElement>(null)
    const closeEyeRef = useRef<HTMLSpanElement>(null)
    const openEyeRef = useRef<HTMLSpanElement>(null)
    const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
    const phoneRegex = /^5\d{8}$/
    const [params] = useSearchParams()
    const token = params.get("token")
    const dispatch = useDispatch()
    const navigate = useNavigate()
    async function handleSubmit() {
        try {
            const response = await axios.post(`${baseUrl}/api/dashboard/users/invitations/accept?locale=${locale}`, {
                password: formik.values.password,
                username: formik.values.userName,
                phone: formik.values.phone === "" ? undefined : formik.values.phone
            }, {
                headers: {
                    Authorization: token
                }
            })
            if (response.data.success === true) {
                toast.success("User Registered Successfully")
                dispatch(setToken(response.data.accessToken));
                dispatch(setUser(response.data.userData));
                dispatch(setResturant(response.data.restaurantData));
                navigate("/")
            } else if (response.data.success === false) {
                toast.error(response.data.error)
            }

        } catch (error) {
            const axiosError = error as AxiosError<{ error: string }>;
            console.error("Axios error:", axiosError);
            toast.error(axiosError.response?.data?.error || "Something went wrong");
        }
    }
    const validationSchema = object({
        password: string()
            .min(8, t("register.passwordMin") as string)
            .required(t("register.passwordRequired") as string)
            .matches(passwordRegex, t("register.passwordComplexity") as string),

        userName: string()
            .required(t("register.usernameRequired") as string)
            .min(3, t("register.usernameMin") as string),

        phone: string()
            .notRequired()
            .test(
                "is-valid-phone",
                t("register.invalidPhone") as string,
                (value) => !value || phoneRegex.test(value)
            )
    });

    const formik = useFormik({
        initialValues: {
            password: "",
            userName: "",
            phone: ""
        },
        validationSchema,
        onSubmit: handleSubmit

    })

    function togglePasswordVisibility() {
        if (passwordRef.current) {
            if (passwordRef.current.type === "password") {
                passwordRef.current.type = "text"
                openEyeRef.current?.classList.remove("hidden")
                closeEyeRef.current?.classList.add("hidden")

            } else {
                passwordRef.current.type = "password"
                openEyeRef.current?.classList.add("hidden")
                closeEyeRef.current?.classList.remove("hidden")
            }
        }
    }

    return (
        <>

            <div className="xl:grid xl:grid-cols-12 ">
                <form
                    onSubmit={formik.handleSubmit}
                    className=" h-[90vh] relative mt-10 flex justify-evenly  flex-col  col-span-4 "
                >

                    <div className="w-[70%] mx-auto" >
                        <AuthLangButton />
                    </div>
                    <div className="w-[90%] md:w-[60%] xl:w-[70%] overflow-y-auto mx-auto">
                        <div className="flex flex-col gap-1 w-full   p-5">

                            <h1 className="  mb-5 text-xl font-semibold">
                                {t("permissions.wellcome")}
                            </h1>
                            <span className="text-slate-400 mb-10">{t("permissions.welcomeMessage")}</span>

                            <div className="flex w-full  flex-col gap-3">
                                <div className="flex flex-col gap-2">
                                    <label htmlFor="" className="font-semibold">{t("register.username")}</label>
                                    <input
                                        onBlur={formik.handleBlur}
                                        value={formik.values.userName}
                                        onChange={formik.handleChange}
                                        name="userName"
                                        type="text"
                                        className="input" placeholder={t("register.usernamePlaceholder") as string} />
                                    {formik.errors.userName && formik.touched.userName && <span className="text-red-500">{formik.errors.userName}</span>}
                                </div>
                                <div className="flex flex-col gap-2 relative">
                                    <label htmlFor="" className="font-semibold">{t("register.password")}</label>
                                    <input
                                        placeholder={t("register.password") as string}
                                        value={formik.values.password}
                                        onChange={formik.handleChange}
                                        ref={passwordRef}
                                        name="password"
                                        type="password"
                                        className="input"
                                        onBlur={formik.handleBlur}
                                    />

                                    <span
                                        ref={openEyeRef}
                                        className={`absolute hidden ${locale === "ar" ? "left-2" : "right-2"} bottom-3 text-slate-400 cursor-pointer`}
                                        onClick={togglePasswordVisibility}
                                    >
                                        <FaRegEye />
                                    </span>

                                    <span
                                        ref={closeEyeRef}
                                        className={`absolute ${locale === "ar" ? "left-2" : "right-2"} bottom-3 text-slate-400 cursor-pointer`}
                                        onClick={togglePasswordVisibility}
                                    >
                                        <FaRegEyeSlash />
                                    </span>

                                </div>
                                {formik.errors.password && formik.touched.password && <span className="text-red-500">{formik.errors.password}</span>}
                                <div className="flex flex-col gap-2 relative">
                                    <label htmlFor="" className="font-semibold">{t("register.phone")}</label>
                                    <input
                                        onBlur={formik.handleBlur}
                                        value={formik.values.phone}
                                        onChange={(e) => {
                                            let value = e.target.value;
                                            if (value.startsWith("0")) {
                                                value = value.substring(1); // Remove leading zero
                                            }
                                            formik.setFieldValue("phone", value);
                                        }}
                                        name="phone"
                                        type="tel"
                                        placeholder={t("register.phone") as string}
                                        className="input ps-16"
                                    />

                                    <span className="absolute  left-2 bottom-2 text-slate-400">{t("+966", "+966")}</span>
                                </div>
                                {formik.errors.phone && formik.touched.phone && <span className="text-red-500">{formik.errors.phone}</span>}


                                <button type="submit" className="my-btn">
                                    {t("register.register")}
                                </button>


                            </div>
                        </div>
                    </div>
                </form>
                <AuthHeroSection />
            </div>


        </>
    )
}
